var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatMap4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 173,
    viewBox: "0 0 118 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_1693_26325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2078 78.6468C20.4836 94.5738 26.1263 106.961 29.2881 111.164C24.2472 131.373 28.6616 146.333 31.499 151.287C43.1966 162.1 39.97 168.715 63.0438 162.828C84.1213 150.149 96.9981 86.5762 102.589 43.2337C98.0929 21.143 88.5334 14.4988 81.8536 11.455C65.6665 3.87695 55.7982 10.4197 51.0896 15.6524C37.7539 26.8077 31.536 43.0095 31.0016 52.702C26.1195 59.7212 23.7715 72.9232 23.2078 78.6468Z",
    fill: "#499FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5446 80.0006C28.3556 93.003 33.1096 103.153 35.7603 106.603C31.6648 123.093 35.4095 135.34 37.7938 139.402C43.5405 151.927 55.9166 154.73 61.3863 154.565C78.7453 157.011 96.5329 88.8884 96.4083 51.4458C97.011 31.4139 86.0188 21.3665 80.4474 18.8468C66.945 12.5755 55.7861 19.5144 51.8944 23.7678C40.8549 32.8193 37.2999 50.9183 36.9024 58.8364C32.8751 64.5488 30.9858 75.3261 30.5446 80.0006Z",
    fill: "#30CB87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2591 119.734C40.0839 123.594 41.7102 128.319 42.4203 130.199C42.5172 133.455 45.2773 137.778 46.6453 139.533C55.4225 146.964 63.1179 146.632 66.7443 145.571C76.4004 145.633 90.5083 105.613 84.7067 85.776L86.6213 74.9295L86.9117 65.0168C94.4821 41.7428 85.068 30.897 80.6032 26.4912C67.0069 17.7305 58.2982 23.5517 52.6206 30.1794C39.4234 46.8599 39.367 61.1106 40.9717 68.9582L41.5257 76.0601L40.5658 90.6103L40.6931 105.326L39.2591 119.734Z",
    fill: "#FFC909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6401 81.8528C41.1197 91.7926 45.6352 100.225 47.9579 103.198C40.4465 112.858 39.675 127.054 40.2282 132.944C40.3703 151.027 56.0254 154.999 63.8352 154.724C79.0247 152.336 86.2094 127.378 87.9031 115.198L86.9663 108.503L86.701 101.803L85.5737 89.0508L84.6991 85.271L84.2042 73.5366C88.5379 63.7493 86.3 50.65 84.6393 45.3237C86.8684 30.7664 83.1756 22.5402 81.0505 20.2467C72.2156 6.83452 59.4471 16.0328 54.1673 22.3084C43.4294 34.1442 42.2671 49.284 43.0282 55.3744C39.1347 69.7628 40.4805 79.0218 41.6401 81.8528Z",
    fill: "#FF2F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1693_26325",
    x: 18.4863,
    y: 4.01074,
    width: 88.1025,
    height: 165.02,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1693_26325"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMap4);
export default __webpack_public_path__ + "static/media/heatMap4.908c47bfd702dcba768cac6b998c5b8d.svg";
export { ForwardRef as ReactComponent };